import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Option } from '@sorare/core/src/components/search/Option';
import { formatScarcity } from '@sorare/core/src/lib/cards';
import type { StatsRarity } from '@sorare/core/src/lib/playerSearchView';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

export const useMarketValueFilterRarity = () => {
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const tickedRarities =
    statsManager[PlayerSearchViewAttributes.MARKET_VALUE_RARITIES];
  const selectedRarity =
    statsManager[PlayerSearchViewAttributes.MARKET_VALUE_FILTER_RARITY];

  return {
    tickedRarities,
    filterRarity: tickedRarities.includes(selectedRarity)
      ? selectedRarity
      : (tickedRarities.at(0) ?? Rarity.limited),
    setFilterRarity: (rarity: StatsRarity) =>
      updatePlayerSearchViewAttribute(
        PlayerSearchViewAttributes.MARKET_VALUE_FILTER_RARITY,
        rarity
      ),
  };
};

export const MarketValueRarityPicker = () => {
  const { tickedRarities, filterRarity, setFilterRarity } =
    useMarketValueFilterRarity();

  return (
    <Vertical gap={0}>
      {tickedRarities.map(rarity => (
        <Option
          key={rarity}
          variant="radio"
          active={rarity === filterRarity}
          onClick={() => setFilterRarity(rarity)}
        >
          <ScarcityIcon rarity={rarity} />
          <span>{formatScarcity(rarity)}</span>
        </Option>
      ))}
    </Vertical>
  );
};
